import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import {useLocale} from "@components/Contexts/LocaleContext"
import Separator from "@components/CustomTypography/Separator/Separator"
import OnePricingSection from "@components/Pages/One/OnePricingSection/OnePricingSection"
import FAQSection from "@components/Pages/Studio/PricingPage/FAQSection/FAQSection"
import PackagesSection from "@components/Pages/Studio/PricingPage/PackagesSection/PackagesSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import getValueOrThrow from "@helpers/getValueOrError"
import {translate} from "@helpers/translate"
import {getLink} from "@hooks/PagesData/getLink"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import OnePricingEnterprise from "@jsons/OnePricingEnterprise.json"
import React from "react"

type Props = {}

const enterprise = (props: Props) => {
	const pageData = getTranslatedPageData(
		OnePricingEnterprise,
		undefined,
		true,
	)
	const mainContent = getValueOrThrow(pageData.AdvancedSideAsset)

	const {locale} = useLocale()

	return (
		<>
			<HeadMeta
				meta={pageData.metaData}
				customPath={"/pricing/one/business"}
			/>
			<PackagesSection
				cards={getValueOrThrow(pageData.pricingCardData)}
				data={mainContent[0]}
				best={3}
				disableCurency
				additionalButton={{
					index: 0,
					link: "https://store.dreambroker.com/licenses?subscription=free-trial",
					title: translate("Try it for free", locale),
				}}
				plans={[
					{
						link: getLink("pricingOneEnterprise"),
						title: "Business Plans",
					},
					{
						link: getLink("pricingOneHome"),
						title: "Home Plans",
					},
				]}
			/>

			<section
				id={"pricing"}
				style={{
					backgroundColor: "#F8FAFE",
				}}
			>
				<Separator size={128}>
					<ContainerWrapper>
						<OnePricingSection />
					</ContainerWrapper>
				</Separator>
			</section>

			<Separator size={128} />
			<FAQSection
				faq={getValueOrThrow(pageData.faqData)}
				pageData={mainContent[1]}
			/>
		</>
	)
}

export default enterprise
